<div class="jumbotron jumbotron-fluid">
    <div class="container">
        <h1 class="display-4">Pre-Plan</h1>
        <p class="lead">Pets at Peace is here to treat your loved one with care and make this process as simple as
            possible for you.</p>
    </div>
</div>